import intlTelInput from "intl-tel-input";

// Initialize the input field
const input = document.querySelector("#contactNumber");
let iti;

if (input) {
  iti = intlTelInput(input, {
    initialCountry: "au", // Default country
    separateDialCode: true, // Shows country code separately
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js"
  });

  // Restrict input to numbers only
  input.addEventListener("input", function () {
    this.value = this.value.replace(/\D/g, ""); // Remove non-numeric characters
  });

  // Prevent pasting non-numeric characters
  input.addEventListener("paste", function (event) {
    event.preventDefault();
    const pastedText = (event.clipboardData || window.clipboardData).getData("text");
    this.value = pastedText.replace(/\D/g, ""); // Allow only numbers
  });
  
  input.addEventListener("countrychange", function () {
    const selectedCountry = iti.getSelectedCountryData();
    const dialCode = selectedCountry.dialCode;
    // console.log("Selected country code:", dialCode);
  
    // Optional: store in hidden field
    document.getElementById("country-code").value = dialCode;
  });
}
